import Users from '../../views/users/Users.vue'
import CreateUser from '../../views/users/CreateUser.vue'
import User from '../../views/users/User.vue'
import UserGeneral from '../../views/users/UserGeneral.vue'
import AuditorQuestionlists from '../../views/users/AuditorQuestionlists.vue'
import AuditorWorkHistory from '../../views/users/AuditorWorkHistory.vue'
import PlannerBrands from '../../views/users/PlannerBrands.vue'
import ConnectedUsers from '../../views/users/ConnectedUsers.vue'
import SupplierContacts from '../../views/users/SupplierContacts.vue'
import UserSuppliers from '../../views/users/UserSuppliers.vue'
import UserBrands from '../../views/users/UserBrands.vue'
import UserNotification from '../../views/users/UserNotification.vue'


import AuditorAuditHistory from '../../views/users/AuditorAuditHistory.vue'
import AuditorVerificationHistory from '../../views/users/AuditorVerificationHistory.vue'
import AuditorTechnicalAuditHistory from '../../views/users/AuditorTechnicalAuditHistory.vue'


import {roleSystemRoute,closeNotificationsModal} from './route_utilities'

    export const users =  {
      path: 'users',
      name: 'Users',
      component: Users,
      beforeEnter : roleSystemRoute,
      meta: {
          title: "kullanicilar",
          domain:"users",
          accessroles:["admin","planner","auditor"],
        },
      }

  export const notification =  {
      path: 'notification/:notification_uuid',
      name: 'UserNotification',
      component: UserNotification,
      beforeEnter : closeNotificationsModal,
      meta: {
          title: "bildirim",
          domain:"users",
        },
      }
export const create_user =  {
      path: 'user',  
      name: 'CreateUser',
      component: CreateUser,
      meta: {
          title: "yeni_kullanici",
          preloader:true,
          domain:"users"
        },
      }

  export const connected_users =  {
  path: 'connected_users',  
  name: 'ConnectedUsers',
  component: ConnectedUsers,
  meta: {
      title: "Online Kullanıcılar",
      preloader:true,
      domain:"users",
      accessroles:["admin","planner","auditor"],
    },
  }

  export const supplier_contacts =  {
  path: 'supplier_contacts',  
  name: 'SupplierContacts',
  component: SupplierContacts,
  meta: {
      title: "Online Kullanıcılar",
      preloader:true,
      domain:"users",
      accessroles:["admin"],
    },
  }
export const user = {
      path: 'user/:id',  
      name: 'User',
      component: User,
      redirect: { name: 'UserGeneral' },
      meta: {
          title: "kullanici",
          preloader:true,
          domain:"users",
          accessroles:["admin","planner","auditor"],
        },
         children:[
          {
          path: 'info',  
          name: 'UserGeneral',
          component: UserGeneral,
          meta: {
              title: "kullanici_bilgileri",
              preloader:true,
              domain:"users"
            },
          },
          {
          path: 'questionlists',  
          name: 'AuditorQuestionlists',
          component: AuditorQuestionlists,
          meta: {
              title: "denetci_soru_listeleri",
              preloader:true,
              domain:"users"
            },
          },
          {
          path: 'work_history',  
          name: 'AuditorWorkHistory',
          component: AuditorWorkHistory,
          meta: {
              title: "denetlemeler",
              preloader:true,
              domain:"users"
            },
          },
          {
          path: 'audit_history',  
          name: 'AuditorAuditHistory',
          component: AuditorAuditHistory,
          meta: {
              title: "denetlemeler",
              preloader:true,
              domain:"users"
            },
          },
          {
          path: 'verification_history',  
          name: 'AuditorVerificationHistory',
          component: AuditorVerificationHistory,
          meta: {
              title: "dogrulamalar",
              preloader:true,
              domain:"users"
            },
          },
          {
          path: 'technical_verification_history',  
          name: 'AuditorTechnicalAuditHistory',
          component: AuditorTechnicalAuditHistory,
          meta: {
              title: "teknik_dogrulamalar",
              preloader:true,
              domain:"users"
            },
          },
          {
          path: 'brands',  
          name: 'PlannerBrands',
          component: PlannerBrands,
          meta: {
              title: "planlamaci_markalari",
              preloader:true,
              domain:"users"
            },
          },
          {
          path: 'user_suppliers',  
          name: 'UserSuppliers',
          component: UserSuppliers,
          meta: {
              title: "kullanici_tedarikcileri",
              preloader:true,
              domain:"users"
            },
          },
          {
          path: 'user_brands',  
          name: 'UserBrands',
          component: UserBrands,
          meta: {
              title: "kullanici_markalari",
              preloader:true,
              domain:"users"
            },
          },
         ],
      }